import init from '../../helpers/init';

const {$} = init;

import 'jquery-pjax';

$(window).on('load', () => {
  $.pjax.defaults.timeout = 20000;
  $.pjax.defaults.scrollTo = false;
});

$(() => {
  $(document).on('change', 'form.js-pjax-filter[data-pjax] :input', (e) => {
    const $target = $(e.target);
    if (!$target.hasClass('select2-search__field')) {
      $target.parents('form.js-pjax-filter').trigger('submit');
    }
  });

  $(document).on('change', 'form.js-pjax-filter[data-pjax] .js-select-multiple', (e) => {
    const value = $(e.target).select2({theme: 'classic'}).val();
    setTimeout(function() {
      $(e.target).prev('.js-pjax-field').val(value).trigger('change');
    }, 10000);
  });

  $(document).on('change', 'form.js-pjax-filter[data-pjax] .js-simple-select', (e) => {
    const value = $(e.target).select2({theme: 'classic'}).val();
    $(e.target).prev('.js-pjax-field').val(value).trigger('change');
  });

  $(document).on('change', 'form.js-pjax-filter[data-pjax] .js-pjax-select', (e) => {
    $(e.target).parents('form.js-pjax-filter').trigger('submit');
  });

  $(document).on('click', '.js-select-date', (e) => {
    e.preventDefault();
    const value = $(e.target).data('id');
    $('.js-select-date').removeClass('active');
    $(e.target).addClass('active');
    $('input.js-date').val(value).trigger('change');
  });

  $(document).on('click', '.js-select-date-link', (e) => {
    e.preventDefault();
    const value = $(e.target).data('id');
    $('.js-select-date-link').parent().removeClass('active');
    $(e.target).parent().addClass('active');
    $('input.js-date').val(value).trigger('change');
  });

  $(document).on('click', 'form.js-pjax-filter[data-pjax] .js-link', (e) => {
    e.preventDefault();
    const value = $(e.target).data('value');
    console.log(value);
    $('.js-pjax-input').val(value);
    $(e.target).parents('form.js-pjax-filter').trigger('submit');
  });

  $(document).on('keyup', '.js-pjax-field', () => {
    const $this = $(this);
    clearTimeout($this.data('timer'));
    $this.data('timer', setTimeout(() => {
      $this.removeData('timer');
      $this.trigger('change');
    }, 10000));
  });

  $(document).on('submit', 'form.js-pjax-filter', (e) => {
    const $target = $(e.target);

    let action = [$target.data('action'), $target.attr('action')].find((a) => typeof a === 'string');

    if (action === '' || action === undefined) {
      $target.data('action', '');
      const searchParams = new URLSearchParams(window.location.search);

      // Remove field names of current form from search params
      Array.from(e.target.elements)
        .map((el: any) => el.name)
        .filter((v, i, a) => a.indexOf(v) === i) // uniq
        .filter((v) => !!v)
        .forEach((name) => searchParams.delete(name));

      action = location.origin + location.pathname;

      if (searchParams.toString() !== '') {
        action += `?${searchParams}`;
      }

      $target.attr('action', action);
    }

    const options = $target.data('pjax');

    if (typeof options.fragment === 'undefined') {
      options.fragment = options.container;
    }

    $.pjax.submit(e, options);

    return false;
  });

  $(document).on('pjax:start', (function (e) {
    if ($(e.target).hasClass('pjax-loading')) {
      let header = $(e.target).find('.online-chat__header');
      $(e.target).addClass('-active');
      if(header){
        header.after($('<div class="preloader"></div>'));
      } else {
        $(e.target).prepend($('<div class="preloader"></div>'));
      }
    }
  })).on('pjax:end', (function (e) {
    if ($(e.target).hasClass('pjax-loading')) {
      $(e.target).removeClass('-active');
      $(e.target).find('.preloader').remove();

      if($(e.target).hasClass('online-chat')){
        $('.js-chat-scroll').each(function() {
          scrollChatBandPjax(this);
        });
      }
    }
  }));

  function scrollChatBandPjax(element: HTMLElement) {
    const wrap = $(element);
    const band = wrap.find('.chat-list');
    const scroll = band.outerHeight() - wrap.outerHeight();
    wrap.animate({
      scrollTop: scroll
    }, 300, () => {
      wrap.find('.chat-preloader').remove();
    });
  }
});

